import { Typography, Link } from '@one-thd/sui-atomic-components';
import { Store, QRCode, BuyAgain } from '@one-thd/sui-icons';
import React, { useEffect, useRef } from 'react';
import { TagOnInStoreInstructionsRender } from '@src/utils/analytics-tagging';
import { ReturnButtons } from '../../shared/ReturnButtons';
import { disableAbandonmentSurvey } from '../../../utils/storage-helper';
import { useReturnStore } from '../../../stores/returnStore';
import { redirectToOrderDetails } from '../../../utils/general';
import OrderNumberBarcode from '../OrderNumberBarcode';

export const Phase0InStoreReturnMethod = () => {
  const hasTaggedInstructionsRender = useRef(false);
  const isMilitaryExchangeGuest = useReturnStore(
    (state) => state.isMilitaryExchangeGuest,
  );
  const orderDetailsPath = useReturnStore((state) => state.orderDetailsPath);
  const militaryExchange = useReturnStore((state) => state.militaryExchange);
  const orderDetailsV2 = useReturnStore((state) => state.orderDetailsV2);
  const paymentMethod = useReturnStore((state) => state.tenders?.[0]?.type);
  const isPTCOrder = useReturnStore((state) => state.isPTCOrder);
  const refundTimingAmount = isPTCOrder ? '1 business day' : '10 business days';
  const inStoreRefundTimingMessage = `It may take up to ${refundTimingAmount} for your bank to put the funds back into your account.`;

  useEffect(() => {
    disableAbandonmentSurvey(); // Safety net to make sure survey is disabled
  }, []);

  // Phase 0 skips Review/Finalize, so tag this render with the same in-store
  // instructions payload used when Return Summary opens its instructions drawer.
  useEffect(() => {
    if (hasTaggedInstructionsRender.current || !orderDetailsV2) {
      return;
    }

    TagOnInStoreInstructionsRender(
      militaryExchange,
      orderDetailsV2,
      paymentMethod,
      isPTCOrder,
    );
    hasTaggedInstructionsRender.current = true;
  }, [isPTCOrder, militaryExchange, orderDetailsV2, paymentMethod]);

  return (
    <div className="sui-max-w-xl" data-testid="phase0-instore">
      <div className="sui-mb-4">
        <Typography weight="bold">In-Store Drop-Off Instructions</Typography>
      </div>

      <OrderNumberBarcode />

      <div className="sui-mb-4 sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <Store />
        </div>

        <Typography>
          Take your return items to any{' '}
          <Link href="https://www.homedepot.com/l/" target="_blank">
            Home Depot store.
          </Link>
        </Typography>
      </div>
      <div className="sui-mb-4 sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <QRCode />
        </div>

        <Typography>
          Show your barcode
          {!isMilitaryExchangeGuest && (
            <>, receipt or the card used at purchase</>
          )}{' '}
          to an associate at the returns counter.
        </Typography>
      </div>
      <div className="sui-flex sui-gap-3">
        <div className="sui-pt-[6px]">
          <BuyAgain />
        </div>

        <Typography>{inStoreRefundTimingMessage}</Typography>
      </div>

      <ReturnButtons
        proceedNext={() =>
          redirectToOrderDetails(orderDetailsPath, isMilitaryExchangeGuest)
        }
        instore
      />
    </div>
  );
};
